<script lang="ts">
  import { canEdit, openAddActivity } from "../lib/stores";
  import WbsPanel from "./WbsPanel.svelte";
  $: editable = $canEdit;
</script>

<div class="tab-panel group">
  <div class="group-head">
    <span class="group-tag lean">WBS</span>
    <span class="group-desc">Organise scope items and work packages. Add activities to a package or click an activity to edit it.</span>
  </div>
  <section>
    <div class="section-head">
      <div class="section-title">Work breakdown structure</div>
      {#if editable}<button class="btn primary" type="button" on:click={() => openAddActivity()}>+ Add activity</button>{/if}
    </div>
    <WbsPanel expanded />
  </section>
</div>
